import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PeopleAnalysisUnlockCardContentInfoItemProps as Props } from './types';

export const PeopleAnalysisUnlockCardContentInfoItem = memo(
  ({ className, text }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames(
          'PeopleAnalysisUnlockCardContentInfoItem',
          className
        )}
        sx={SX.root}
      >
        <Stack>
          <Icon name="info" color="grey.400" size={12} />
        </Stack>
        <Typography variant="body4" fontWeight={500} color="black" sx={SX.text}>
          {text}
        </Typography>
      </Styled.Wrapper>
    );
  }
);

PeopleAnalysisUnlockCardContentInfoItem.displayName =
  'PeopleAnalysisUnlockCardContentInfoItem';
